import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { Router } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-d3-citree',
    templateUrl: './d3-citree.component.html',
    styleUrls: ['./d3-citree.component.scss'],
    standalone: false
})
export class D3CitreeComponent implements OnChanges, AfterViewInit, OnInit {


  constructor(private el: ElementRef,
    private router: Router,
    private utilSer: UtilsService,
    private datePipe: DatePipe,
  ) {
    this.factoryid = sessionStorage.getItem('selectedFactory') ?
      JSON.parse(sessionStorage.getItem('selectedFactory')).name : null;
    console.log(this.factoryid, 'this.factoryid')
    this.clusterid = sessionStorage.getItem('selectedCluster') ?
      JSON.parse(sessionStorage.getItem('selectedCluster')).clusterName : null;
    console.log(this.clusterid, 'this.clusterid')
  }
  ngOnInit(): void {

  }
  @Input() data: any = null;
  @Input() navigatePath: string = '/c-and-i/zoom-in-view';
  @Input() clusterid: any;
  @Input() factoryid: any;
  @Input() treeData: any;
  @Input() usecaseid: any;
  @Input() iscompare = false
  @ViewChild('treeSvg', { static: true }) treeSvg!: ElementRef<SVGSVGElement>;

  private defaultData = {

  };


  ngAfterViewInit() {
    this.drawTree();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data && this.data.targetParameterData && this.treeSvg) {
      this.drawTree();
    }

  }
  private drawTree(): void {
    const componentRef = this;
    const usecaseid = this.usecaseid;
    const iscompare = this.iscompare;
    const data = this.data.targetParameterData || this.defaultData;
    data.lastRefreshedEpoch = this.datePipe.transform(this.utilSer.timeStampConverter(data?.lastRefreshedEpoch * 1000, false), "MMM d, y, HH:mm")
    const svg1 = d3.select(this.el.nativeElement).select('svg');

    // if (!svg1.empty()) {
    //   debugger;
    //   svg1.on('click', () => {
    //     console.log('Navigating to zoom in view', data, this.clusterid, this.factoryid);
    //     // this.router.navigate(['../configurator/parameterization'], data);
    //     this.router.navigate([this.utilSer.selectedClusterFactoryURLCreator(this.clusterid, this.factoryid) + '/c-and-i/zoom-in-view'], data);

    //   })
    // };
    const timeseriesData = this.data.timeseriesdata || [];


    new Date(this.utilSer.timeStampConverter(+data * 1000, false))
    // Count the number of leaf nodes (or max depth)
    const treeData = d3.hierarchy(data, d => d.machines || d.parameters);
    const leaves = treeData.leaves().length;
    const nodeHeight = 30; // or whatever your node height + vertical spacing is
    const minHeight = 600; // minimum height for small trees
    const legendData = [
      { color: '#0fbe52', label: 'Within Specification limit' },
      { color: '#f44336', label: 'Outside Specification limit' },
      { color: '#FFD700', label: 'Above control limit' },
    ];
    // Dynamically calculate height based on number of leaves - add generous space for large node counts
    // const spacingPerNode = leaves > 100 ? 20 : (leaves > 50 ? 18 : 15);
    // const extraMargin = leaves > 100 ? 800 : (leaves > 50 ? 600 : 300);
    // const calculatedHeight = Math.max((leaves * nodeHeight) + (leaves * spacingPerNode) + extraMargin, minHeight);
    const calculatedHeight = Math.max(leaves * nodeHeight + (leaves * 15), minHeight) + 100; // 30 is extra per node, 100 for margin

    console.log(calculatedHeight, 'calculatedHeight', 'leaves:', leaves)
    d3.select(this.treeSvg.nativeElement)
      .attr('height', calculatedHeight);

    const svg = d3.select(this.treeSvg.nativeElement);
    svg.selectAll('*').remove();


    // Draw legend in upper left
    const legendGroup = svg.append('g')
      .attr('class', 'legend')
      .attr('transform', 'translate(10, 20)'); // adjust position as needed

    const legendItemHeight = 22;

    legendGroup.selectAll('g.legend-item')
      .data(legendData)
      .enter()
      .append('g')
      .attr('class', 'legend-item')
      .attr('transform', (d, i) => `translate(0, ${i * legendItemHeight})`)
      .each(function (d) {
        d3.select(this)
          .append('rect')
          .attr('x', 0)
          .attr('y', -8)
          .attr('text-anchor', 'start')
          .style('font-size', '10px')
          .attr('width', 18)
          .attr('height', 18)
          .attr('rx', 4)
          .attr('ry', 4)
          .attr('fill', d.color)

          .attr('stroke', '#333')
          .attr('stroke-width', 1);

        const wrapLength = iscompare ? 30 : 50; // max characters per line

        d3.select(this)
          .append('text')
          .attr('x', 28)
          .attr('y', 6)
          .attr('text-anchor', 'start')
          .style('font-size', '10px')
          .style('fill', '#222')
          .selectAll('tspan')
          .data(wrapTextByWord(d.label, wrapLength))
          .enter()
          .append('tspan')
          .attr('x', 28)
          .attr('dy', (line, i) => i === 0 ? 0 : '1.2em') // vertical spacing between lines
          .text(line => line);
      });

    const width = +svg.attr('width');
    const height = +svg.attr('height');
    const g = svg.append('g').attr('transform', 'translate(100,0)');
    // Use new property names for children
    const tree = d3.tree().size([height, width - 180]);
    let i = 0;
    let duration = 750;
    // Use new property names for children
    let root = d3.hierarchy(data, d =>
      d.machines || d.parameters // root: machines, machine: parameters
    );
    (root as any).x0 = height / 2;
    (root as any).y0 = 0;

    root.sort((a: any, b: any) => {
      if (a.data.parameterCorrelationValue !== undefined && b.data.parameterCorrelationValue !== undefined) {
        return Math.abs(b.data.parameterCorrelationValue) - Math.abs(a.data.parameterCorrelationValue);
      }
      return 0;
    });

    update(root);

    function getNodeSize(d: any) {
      if (d.depth === 0) return 110;    // root height (unchanged)
      if (d.depth === 1) return iscompare ? 22 : 30;     // middle node (machine) taller for icon + text
      return iscompare ? 20 : 25;
    }
    function getNodeSizeWidth(d: any) {
      if (d.depth === 0) return iscompare ? 190 : 300;    // root width (unchanged)
      if (d.depth === 1) return iscompare ? 120 : 230;    // middle node (machine) wider for icon + text
      return iscompare ? 200 : 430;
    }

    function getNodeText(d: any) {
      // Use correct property for each node type
      let txt = '';
      if (d.depth === 0) txt = d.data.parametername + ', LSL:' + d.data.parameterLSL + ', USL:' + d.data.parameterUSL || '';
      else if (d.depth === 1) txt = d.data.machineName || '';
      else if (d.depth === 2) txt = d.data.parameterName + ', LSL:' + d.data.parameterLSL + ', Act:' + d.data.currentValue + ', USL:' + d.data.parameterUSL || '';
      return iscompare ? txt.length > 35 ? txt.slice(0, 33) + '..' : txt : txt.length > 70 ? txt.slice(0, 68) + '..' : txt;
    }

    function getUsecaseText(d: any) {
      // Only root node has usecase
      const txt = d.data.usecase || '';
      return txt.length > 25 ? txt.slice(0, 23) + '..' : txt;
    }

    function getNodeColor(d: any) {
      // #f44336 red
      // #0fbe52 green
      const rawColor = d.depth === 0 ? d.data.targetParameterColourCode : d.data.colourCode;

      if (!rawColor) {
        return d.depth === 0 ? '#FFD700' : '#ADD8E6';
      }

      const lowerColor = rawColor.toLowerCase();

      if (lowerColor === 'green') return '#0fbe52';
      if (lowerColor === 'red') return '#ed4343';
      if (lowerColor === 'grey' || lowerColor === 'gray') return '#9e9e9e';

      return rawColor;
    }

    // Helper function to lighten a color
    function lightenColor(color: string, percent: number): string {
      const num = parseInt(color.replace('#', ''), 16);
      const amt = Math.round(2.55 * percent);
      const R = Math.min(255, (num >> 16) + amt);
      const G = Math.min(255, (num >> 8 & 0x00FF) + amt);
      const B = Math.min(255, (num & 0x0000FF) + amt);
      return '#' + (0x1000000 + (R < 255 ? R : 255) * 0x10000 +
        (G < 255 ? G : 255) * 0x100 + (B < 255 ? B : 255))
        .toString(16).slice(1);
    }



    // Helper function to get dark and light variants for animation
    function getBlinkColors(d: any) {
      const baseColor = d3.color(getNodeColor(d));
      const dark = baseColor ? baseColor.darker(0.8).toString() : '#2b3035ff';
      const light = baseColor ? baseColor.darker(-0.8).toString() : '#7a6d6d';
      return { dark, light };
    }

    function update(source: any) {
      const treeData = tree(root);
      const nodes = treeData.descendants();
      const links = treeData.descendants().slice(1);

      const corrBoxWidth = 45;
      const gap = 4;

      // Add vertical space between child nodes - use consistent spacing
      let prevDepth = -1, yOffset = 0;
      nodes.forEach((d, idx) => {
        if (d.depth !== prevDepth) {
          yOffset = 0;
          prevDepth = d.depth;
        }
        if (d.depth > 0) {
          d.x = d.x + yOffset;
          yOffset += 0; // Reduced spacing from 2 to 1 to compact tiles closer
        }
      });

      nodes.forEach(d => d.y = d.depth * (iscompare ? 200 : 350)); // Increase link length

      const node = g.selectAll('g.node')
        .data(nodes, (d: any) => d.id || (d.id = ++i));

      const nodeEnter = node.enter().append('g')
        .attr('class', 'node')
        .attr('transform', (d: any) => `translate(${source.y0},${source.x0})`)
        .on('click', function (event: any, d: any) {
          if (d.children) {
            d._children = d.children;
            d.children = null;
          } else {
            d.children = d._children;
            d._children = null;
          }
          update(d);
        });

      // Draw square nodes
      // Draw outer rect (white fill, orange stroke for root)
      nodeEnter.append('rect')
        .attr('x', (d: any) => -getNodeSizeWidth(d) / (iscompare ? 2 : 6))
        .attr('y', (d: any) => -getNodeSize(d) / 2)
        .attr('width', (d: any) => getNodeSizeWidth(d))
        .attr('height', (d: any) => d.depth === 0 && !iscompare ? getNodeSize(d) + 20 : getNodeSize(d))
        .attr('rx', (d: any) => d.depth === 1 ? Math.ceil(getNodeSize(d) / 2) : 8)
        .attr('ry', (d: any) => d.depth === 1 ? Math.ceil(getNodeSize(d) / 2) : 8)
        .style('fill', (d: any) => {
          if (d.depth === 0) return '#ffffff';      // root: white fill
          if (d.depth === 1) return getNodeColor(d); // middle: colored pill
          return getNodeColor(d);                   // child: colored (keeps previous behavior)
        })
        .style('stroke', (d: any) => d.depth === 0 ? getNodeColor(d) : (d.depth === 1 ? 'none' : '#91AB98'))
        .style('stroke-width', (d: any) => d.depth === 0 ? 3 : (d.depth === 1 ? 0 : 1));

      // If root node, draw a colored top band and put all top texts inside it,
      // then draw dots/labels in the white lower section.
      nodeEnter.filter((d: any) => d.depth === 0)
        .each(function (d: any) {
          const gNode = d3.select(this);
          const totalH = getNodeSize(d);
          const totalW = getNodeSizeWidth(d);

          const topH = Math.round(totalH * 0.68); // proportion for top orange area (tweak as needed)
          const bottomH = totalH - topH;
          const outerX = -totalW / (iscompare ? 2 : 6);
          const topY = -totalH / 2; // y of top rect

          // top orange band (rounded only on top corners visually)
          // using full rx will round all corners; it's acceptable. If you need only top corners rounded,
          // change to a path instead.
          gNode.append('rect')
            .attr('x', outerX + 1) // slight inset so stroke remains visible
            .attr('y', topY + 1)
            .attr('width', totalW - 2)
            .attr('height', topH - 2)
            .attr('rx', 7)
            .attr('ry', 7)
            .style('fill', getNodeColor(d))
            .style('stroke', 'none');


          const modelAccuracy = data.currentModelAccuracy;

          svg.append('g')
            // .data(modelAccuracy)
            .attr('class', 'model-accuracy')
            .attr('transform', 'translate(10, 100)')
            .append('text')
            .text(`Model Accuracy(Last 4 hrs): ${modelAccuracy ? modelAccuracy + '%' : ''}`)
            .attr('fill', '#333')
            .attr('font-size', '10px')
            .attr('font-weight', '600');
          // create a group centered vertically inside the top band for texts
          const topTextY = topY + Math.round(topH / 2);
          const txtGroup = gNode.append('g').attr('transform', `translate(0, ${topTextY})`);

          // Usecase (first line)
          txtGroup.append('text')
            .attr('x', (iscompare ? 0 : 90))
            .attr('y', -12)
            .attr('text-anchor', iscompare ? 'middle' : 'middle')
            .style('font-size', '12px')
            .style('fill', '#fff')
            .style('font-weight', '600')
            .text(() => {
              const name = (d.data as any).useCaseName || (d.data as any).usecase || '';
              const maxLength = 25;
              return `Usecase: ${name.length > maxLength ? name.slice(0, maxLength) + '...' : name}`;
            });
          txtGroup.on('click', function (event, d) {
            const nodeData: any = d;
            componentRef.router.navigate([componentRef.utilSer.selectedClusterFactoryURLCreator(componentRef.clusterid, componentRef.factoryid) + '/c-and-i/zoom-in-view'],
              {
                state: {
                  usecaseid: componentRef.usecaseid,
                  data: data
                }
              });
          });

          // Target (second line)
          txtGroup.append('text')
            .attr('x', (iscompare ? 0 : 100))
            .attr('y', 4)
            .attr('text-anchor', iscompare ? 'middle' : 'middle')
            .style('font-size', '11px')
            .style('fill', '#fff')
            .text(() => {
              const name = (d.data as any).parametername + ', LSL:' + (d.data as any).parameterLSL + ', USL:' + (d.data as any).parameterUSL || '';
              const maxLength = (iscompare ? 24 : 45);
              return `Target: ${(name.length > maxLength ? name.slice(0, maxLength) + "..." : name)

                }`;

            });
          // Current value (third line or small)
          txtGroup.append('text')
            .attr('x', (iscompare ? 0 : 150))
            .attr('y', 18)
            .attr('text-anchor', iscompare ? 'middle' : 'middle')
            .style('font-size', '11px')
            .style('fill', '#fff')
            .text(() => `Current Value: ${(d.data as any).value !== undefined ? (d.data as any).value + '' : ''} \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0`);

          // Refreshed At - put just under current value if room (slightly inside top area)
          txtGroup.append('text')
            .attr('x', (iscompare ? 0 : 90))
            .attr('y', 32)
            .attr('text-anchor', iscompare ? 'middle' : 'middle')
            .style('font-size', '10px')
            .style('fill', '#fff')
            .text(() => `Refreshed At: ${(d.data as any).lastRefreshedEpoch !== undefined ? (d.data as any).lastRefreshedEpoch : ''} `);

          // Forecast dots + numbers go into the white bottom area.
          if (timeseriesData && Array.isArray(timeseriesData)) {
            const dotGroupY = Math.round(topH / 2); // relative to node center; places dots inside bottom white part
            const dotGroup = gNode.append('g')
              .attr('class', 'forecast-dots')
              .attr('transform', `translate(0, ${dotGroupY})`);

            const dotSpacing = (iscompare ? 30 : 40);
            const dotRadius = 5.5;
            const startX = iscompare ? -((timeseriesData.length - 1) * dotSpacing) / 2 : 40;
            const endX = startX + (timeseriesData.length - 1) * dotSpacing;

            // horizontal center line for the dots (draw first so circles are on top)
            dotGroup.append('line')
              .attr('x1', startX - dotSpacing / 2)
              .attr('x2', endX + dotSpacing / 2)
              .attr('y1', iscompare ? -5 : 15) // align with dot center (same as circle cy)
              .attr('y2', iscompare ? -5 : 15)
              .attr('stroke', '#dfd7d7ff') // tweak color as needed
              .attr('stroke-width', 2)
              .attr('stroke-linecap', 'round')
              .attr('class', 'dot-center-line');

            dotGroup.selectAll('circle')
              .data(timeseriesData)
              .enter()
              .append('circle')
              .attr('cx', (d: any, i: number) => startX + i * dotSpacing)
              .attr('cy', iscompare ? -5 : 15)
              .attr('r', dotRadius)
              .attr('fill', (d: any) => {
                const incomingColour = d.colorCode.toLowerCase();
                if (incomingColour === 'red') {
                  return '#f44336';
                } else if (incomingColour === 'green') {
                  return '#0fbe52'
                } else {
                  return d.colorCode || 'gray';
                }
              })
              .append('title')
              .text((d: any) => `Value: ${d.value} `);

            // labels below dots (white background area)
            // labels below dots
            const bottomLabels = dotGroup.append('g').attr('class', 'bottom-labels');

            bottomLabels.selectAll('text')
              .data(timeseriesData)
              .enter()
              .append('text')
              .attr('x', (d, i) => startX + i * dotSpacing)
              .attr('y', iscompare ? 10 : 30)
              .attr('text-anchor', 'middle')
              .style('font-size', '10px')
              .attr('fill', '#0c0c0c')
              .text((d, i) => i === 0 ? '0' : `+ ${i * (d.forecastInterval || data.forecastInterval || 1)}`);


            // labels above dots
            const topLabels = dotGroup.append('g').attr('class', 'top-labels');

            topLabels.selectAll('text')
              .data(timeseriesData)
              .enter()
              .append('text')
              .attr('x', (d, i) => startX + i * dotSpacing)
              .attr('y', 5)
              .attr('text-anchor', 'middle')
              .style('font-size', '10px')
              .attr('fill', '#0c0c0c')
              .text(d => iscompare ? '' :
                ((String(d.value).replace('.', '').length <= 4)
                  ? String(d.value)
                  : (String(d.value).replace('.', '').slice(0, 4)
                    .replace(
                      new RegExp(`^(\\d{${String(d.value).split('.')[0].length}})(\\d*)$`),
                      (_, a, b) => b ? a + '.' + b : a
                    )
                  )
                )
              );

            const minsLable = dotGroup.append('g').attr('class', 'min-labels');

            minsLable.selectAll('text')
              .data(timeseriesData)
              .enter()
              .append('text')
              .attr('x', (d, i) => (startX + i * dotSpacing) - 40)
              .attr('y', iscompare ? 5 : 30)
              .attr('text-anchor', 'middle')
              .style('font-size', '10px')
              .attr('fill', '#0c0c0c')
              .text((d, i) => iscompare ? '' : i === 0 ? 'Min' : '');

            const valLable = dotGroup.append('g').attr('class', 'val-labels');

            valLable.selectAll('text')
              .data(timeseriesData)
              .enter()
              .append('text')
              .attr('x', (d, i) => (startX + i * dotSpacing) - 40)
              .attr('y', 5)
              .attr('text-anchor', 'middle')
              .style('font-size', '10px')
              .attr('fill', '#0c0c0c')
              .text((d, i) => iscompare ? '' : i === 0 ? 'Value' : '');

          }

          // (optional) small orange arrow-box inside right edge — keep it small and inset
          // const arrowBoxW = iscompare ? 22 : -42;
          // const arrowInset = 0;
          // const arrowX = totalW / 2 - arrowBoxW - arrowInset;

          // white arrow inside arrow-box
          const centerX = iscompare ? 80 : 220;
          const centerY = 0;
          const arrowSize = 9;
          const points = [
            `${centerX - 2} `, `${centerY - arrowSize / 2} `,
            `${centerX + arrowSize} `, `${centerY} `,
            `${centerX - 2} `, `${centerY + arrowSize / 2} `
          ].join(' ');
          gNode.append('polygon')
            .attr('points', points)
            .style('fill', '#ffffff');
        });

      // middle nodes (machines) -> show icon + left-aligned text inside pill
      nodeEnter.filter((d: any) => d.depth === 1)
        .each(function (d: any) {
          const g = d3.select(this);
          const h = getNodeSize(d);
          const w = getNodeSizeWidth(d) - 5;
          const iconSize = 18;
          const paddingLeft = (iscompare ? 10 : 50);
          const imageX = -w / 2 + paddingLeft;
          const imageY = -h / 2 + (h - iconSize) / 2;
          const textX = imageX + iconSize + (iscompare ? 8 : 150);
          const nodeWidth = getNodeSizeWidth(d);
          const startX = -nodeWidth / (iscompare ? 2 : 6);
          const exactCenter = startX + (nodeWidth / 2);

          // machine icon (use d.data.machineIcon or fallback)
          // g.append('image')
          //   .attr('xlink:href', (d.data && d.data.machineIcon) ? d.data.machineIcon : 'assets/icons/machine2.png')
          //   .attr('x', imageX)
          //   .attr('y', imageY)
          //   .attr('width', iconSize)
          //   .attr('height', iconSize)
          //   .attr('preserveAspectRatio', 'xMidYMid meet');

          // text left-aligned
          g.append('text')
            .attr('x', exactCenter)
            .attr('y', 5)
            .attr('text-anchor', 'middle')
            .style('font-size', '12px')   // increased font size for machine nodes
            .style('fill', '#fff')
            .text(() => {
              const txt = getNodeText(d);
              const maxChars = iscompare ? 18 : 40;
              return txt.length > maxChars ? txt.slice(0, maxChars - 2) + '..' : txt;
            });
        });

      // child/parameter nodes (depth >= 2) -> keep original centered small text
      // nodeEnter.filter((d: any) => d.depth >= 2)
      //   .append('text')
      //   .attr('dx', (d: any) => {
      //     const width = getNodeSizeWidth(d);
      //     const startX = -width / (iscompare ? 2 : 6);


      //     if (d.depth === 2) {
      //       return startX + 50;
      //     }

      //     return startX + (width / 2);
      //   })
      //   .attr('dy', 5)
      //   .attr('text-anchor', (d: any) => d.depth === 2 ? 'start' : 'middle')
      //   .style('font-size', '12px')   // increased font size for parameter/child nodes
      //   .style('fill', '#fff')
      //   .text(d => getNodeText(d));


      const leaf = nodeEnter.filter((d: any) => d.depth === 2);

      leaf.each(function (d: any) {
        const group = d3.select(this);
        const currentData = d; // Capture the data in closure

        const totalW = getNodeSizeWidth(d);
        const h = getNodeSize(d);
        const startX = -totalW / (iscompare ? 2 : 6);
        const startY = -h / 2;

        const corrW = 45;
        const gap = 4;

        const remainingW = totalW - corrW - (gap * 2);
        const nameW = remainingW * 0.47;
        const valW = remainingW * 0.53;

        //coefficient correlation
        const r = 6;

        // group.append('path')
        //   .attr('d', `
        //   M ${startX + r}, ${startY}
        //   H ${startX + corrW}
        //   V ${startY + h}
        //   H ${startX + r}
        //   A ${r},${r} 0 0, 1 ${startX + r},${startY}
        //   Z
        //   `)
        //   .style('fill', '#3b3b4f')

        const box1 = group.append('g');

        const corrBox1 = box1.append('rect')
          .attr('x', startX)
          .attr('y', startY)
          .attr('width', corrW)
          .attr('height', h)
          .attr('rx', 6)
          .attr('ry', 6)
          .style('fill', '#0085ca')
          .style('--blink-dark-blue', '#0085ca')
          .style('--blink-light-blue', '#4DB8E0');

        const corrBox2 = box1.append('rect')
          .attr('x', startX + (corrW / 2))
          .attr('y', startY)
          .attr('width', corrW / 2)
          .attr('height', h)
          .style('fill', '#0085ca')
          .style('--blink-dark-blue', '#0085ca')
          .style('--blink-light-blue', '#4DB8E0');

        // conditionally apply blink-tile-blue class based on d.data.isRootCause
        corrBox1.classed('blink-tile-blue', currentData.data && currentData.data.isRootCause);
        corrBox2.classed('blink-tile-blue', currentData.data && currentData.data.isRootCause);

        box1.append('text')
          .attr('dy', '.30em')
          .attr('x', startX + (corrW / 2))
          .attr('text-anchor', 'middle')
          .style('fill', '#ffffff')
          .style('font-size', '12px')
          .style('font-weight', 'bold')
          .text((d: any) => {
            const val = d.data.parameterCorrelationValue;
            if (val === undefined || val === null) {
              return '';
            }

            return val > 0 ? `+ ${val}` : `- ${Math.abs(val)}`
          });

        //parameter box
        const nameX = startX + corrW + gap;
        const box2 = group.append('g');
        box2.append('title').text(() => d.data.parameterName || 'N/A');

        const parameterRect = box2.append('rect')
          .attr('x', nameX)
          .attr('y', startY)
          .attr('width', nameW)
          .attr('height', h)
          .style('fill', (d: any) => getNodeColor(currentData))
          .style('--blink-dark', (d: any) => getNodeColor(currentData))
          .style('--blink-light', (d: any) => lightenColor(getNodeColor(currentData), 30))
          .classed('blink-tile', currentData.data && currentData.data.isRootCause);

        const nameText = box2.append('text')
          .attr('x', nameX + 3)
          .attr('dy', 5)
          .attr('text-anchor', 'start')
          .style('font-size', '12px')   // increased font size for parameter/child nodes
          .style('fill', '#fff')
          .text((d: any) => {
            const name = d.data.parameterName || '';
            const maxLen = iscompare ? 12 : 28;

            return name.length > maxLen ? name.slice(0, maxLen - 2) + '..' : name;
          });

        // values of lsl, usl and act
        const valX = nameX + nameW + gap;
        const box3 = group.append('g');

        box3.append('title').text(() => {
          const lsl = d.data.parameterLSL ?? 'NA';
          const act = d.data.currentValue ?? 'NA';
          const usl = d.data.parameterUSL ?? 'NA';

          return `LSL: ${lsl} Act: ${act} USL: ${usl}`;
        });

        const valuesPath = box3.append('path')
          .attr('d', `
          M ${valX}, ${startY}
          H ${valX + valW - r}
          A ${r},${r} 0 0, 1 ${valX + valW},${startY + r}
          V ${startY + h - r}
          A ${r},${r} 0 0, 1 ${valX + valW - r},${startY + h}
          H ${valX}
          Z
          `)
          .style('fill', () => getBlinkColors(currentData).dark)
          .style('--blink-dark-val', () => getBlinkColors(currentData).dark)
          .style('--blink-light-val', () => getBlinkColors(currentData).light)
          .classed('blink-tile-dark', currentData.data && currentData.data.isRootCause);

        // group.append('rect')
        //   .attr('x', valX)
        //   .attr('y', startY)
        //   .attr('width', valW)
        //   .attr('height', h)
        //   .attr('rx', 6)
        //   .attr('ry', 6)
        //   .style('fill', () => {
        //     const baseColor = d3.color(getNodeColor(d));

        //     return baseColor ? baseColor.darker(0.8).toString() : '#2b3035ff'
        //   });


        box3.append('text')
          .attr('x', valX + (valW / 2))
          .attr('dy', 5)
          .attr('text-anchor', 'middle')
          .style('font-size', '12px')   // increased font size for parameter/child nodes
          .style('fill', '#fff')
          .text((d: any) => {
            const lsl = d.data.parameterLSL ?? 'NA';
            const act = d.data.currentValue ?? 'NA';
            const usl = d.data.parameterUSL ?? 'NA';

            const fullText = `LSL:${lsl} Act:${act} USL:${usl}`;
            const maxLen = iscompare ? 11 : 45;
            return fullText.length > maxLen ? fullText.slice(0, maxLen - 2) + '..' : fullText;
          });

      });


      // nodeEnter.filter((d: any) => d.depth === 2)
      //   .append('rect')
      //   .attr('x', (d: any) => (-getNodeSizeWidth(d) / (iscompare ? 2 : 6)) + (corrBoxWidth / 2))
      //   .attr('y', (d: any) => -getNodeSize(d) / 2)
      //   .attr('width', corrBoxWidth / 2)
      //   .attr('height', (d: any) => getNodeSize(d))
      //   .style('fill', '#3B3B4F');













      const nodeUpdate = nodeEnter.merge(node as any);

      nodeUpdate.transition()
        .duration(duration)
        .attr('transform', (d: any) => `translate(${d.y}, ${d.x})`);

      const nodeExit = node.exit().transition()
        .duration(duration)
        .attr('transform', (d: any) => `translate(${source.y}, ${source.x})`)
        .remove();

      nodeExit.select('rect').style('fill-opacity', 1e-6);
      nodeExit.select('text').style('fill-opacity', 1e-6);

      // Draw links
      const link = g.selectAll('path.link')
        .data(links, (d: any) => d.id);

      const linkEnter = link.enter().insert('path', 'g')
        .attr('class', 'link')
        .attr('stroke', '#91AB98')
        .attr('stroke-width', 1.5)
        .attr('fill', 'none')
        .attr('d', (d: any) => {
          const o = { x: source.x0, y: source.y0 };
          return diagonal(o, o);
        });

      const linkUpdate = linkEnter.merge(link as any);

      linkUpdate.transition()
        .duration(duration)
        .attr('d', (d: any) => diagonal(d, d.parent));

      link.exit().transition()
        .duration(duration)
        .attr('d', (d: any) => {
          const o = { x: source.x, y: source.y };
          return diagonal(o, o);
        })
        .remove();

      nodes.forEach(d => {
        (d as any).x0 = d.x;
        (d as any).y0 = d.y;
      });
      nodeEnter.append('title')
        .text((d: any) => {
          if (d.depth === 0) return d.data.parametername + ', LSL:' + d.data.parameterLSL + ', USL:' + d.data.parameterUSL || '';
          if (d.depth === 1) return d.data.machineName || '';
          // if (d.depth === 2) return d.data.parameterName + ', LSL:' + d.data.parameterLSL + ', Act:' + d.data.currentValue + ', USL:' + d.data.parameterUSL || '';
          return '';
        });
    }

    function diagonal(s: any, d: any) {
      // If source is root node, offset x by node height/2 + dots + margin
      let rootYOffset = 0;
      if (s.depth === 0) {
        rootYOffset = getNodeSize(s) / 2 + 35 + 5 + 8; // 35: dot group, 5: dot radius, 8: margin
      }
      const sx = s.depth === 0 ? s.x + rootYOffset : s.x;
      const dx = d.x;
      return `M ${s.y} ${sx}
          C ${(s.y + d.y) / 2} ${sx},
            ${(s.y + d.y) / 2} ${dx},
            ${d.y} ${dx} `;
    }

    function wrapTextByWord(text, maxCharsPerLine) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = '';

      words.forEach(word => {
        if ((currentLine + word).length <= maxCharsPerLine) {
          currentLine += (currentLine ? ' ' : '') + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      });

      if (currentLine) lines.push(currentLine);
      return lines;
    }
  }

}